import { render, staticRenderFns } from "./ActivityForm.vue?vue&type=template&id=a1b97680&"
import script from "./ActivityForm.vue?vue&type=script&lang=ts&"
export * from "./ActivityForm.vue?vue&type=script&lang=ts&"
import style0 from "./ActivityForm.vue?vue&type=style&index=0&id=a1b97680&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports